export default __webpack_public_path__ + "static/media/tos.15fb2579.md";